import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { ButtonRed } from '../../components/common/Button'
import Header from '../../components/common/Header'
import { AuthInput, Input } from '../../components/common/Input'
import { ErrorValidator } from '../../components/common/Validator'
import { Monetization } from '../../components/post'
import './uploadpost.sass'
import "cropperjs/dist/cropper.css";
import Cropper from "react-cropper";
import { uploadPost } from '../../api/feed'

export default function UploadPost() {
    const [body, setBody] = useState('')
    const [monitization, setMonitization] = useState(0);
    const [location, setLocation] = useState('')
    const [priceError, setPriceError] = useState(null);
    const [price, setPrice] = useState(0)
    const [readyToUpload, setReadyToUpload] = useState(false);
    const [uploadBtnState, setUploadBtnState] = useState('UPLOAD');
    const [width, setWidth] = useState(document.body.clientWidth);
    const [isMobile, setIsMobile] = useState(false);
    const [isMediaSelected, setIsMediaSelected] = useState(false)
    const [mediaType, setMediaType] = useState(0);
    const [videoMedia, setVideoMedia] = useState(null);
    const [imageMedia, setImageMedia] = useState(null)

    const [cropper, setCropper] = useState();

    const isDark = useSelector(state => state.isDark)
    const userData = useSelector(state => state.userState)
    const history = useHistory();

    const updateWidth = () => {
        setWidth(document.body.clientWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', updateWidth)
        if (width < 580) {
            setIsMobile(true)
            document.getElementById('mobileWrapper').style.display = 'none'
            document.getElementById('mainWrapper').style.cssText = "padding: 70px 0 70px 0 !important"
        } else {
            setIsMobile(false)
            document.getElementById('mobileWrapper').style.display = 'flex'
            document.getElementById('mainWrapper').style.cssText = "padding: 85px 0 0 0 !important"
        }

        return () => {
            window.removeEventListener('resize', updateWidth);
            document.getElementById('mobileWrapper').style.display = 'flex'
        }
    }, [width])


    const handlePrice = (e) => {
        const fPrice = parseFloat(e.target.value);
        if (isNaN(fPrice)) {
            setPriceError(null);
            console.log("we have a nan")
            setPrice("")
            return;
        }
        if (fPrice < 0)
            setPriceError("Can't be negative")
        else if (fPrice > 60)
            setPriceError('Max limit is $60')
        else
            setPriceError(null)

        if (fPrice > 0 && fPrice <= 60)
            setPrice(e.target.value);
    }

    const handleUploadPost = () => {
        alert("to kar na , karta kyu nahi (in arvind kejriwal voice)")
    }

    const goback = () => {
        history.goBack();
    }


    const handleOnDrop = ev => {
        ev.preventDefault()
        setIsMediaSelected(true);
        if (ev.dataTransfer.items[0].getAsFile().type.includes('image')) {
            setMediaType(1)
            setImageMedia(URL.createObjectURL(ev.dataTransfer.items[0].getAsFile()))
        } else {
            setVideoMedia(URL.createObjectURL(ev.dataTransfer.items[0].getAsFile()))

            setMediaType(2)
        }
    }

    const handleOnDragOver = e => {
        e.preventDefault()

    }


    const handleMediaChange = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setIsMediaSelected(true);



        try {
            if (e.target.files[0].type.includes('image')) {
                setMediaType(1)
                setImageMedia(URL.createObjectURL(e.target.files[0]))
            } else {
                setVideoMedia(URL.createObjectURL(e.target.files[0]))

                setMediaType(2)
            }
        } catch (e) {
            setIsMediaSelected(false);
            setImageMedia(null);
            setVideoMedia(null)
        }
    }

    const handleRemoveMediaFile = (e) => {
        setIsMediaSelected(false);
        setImageMedia(null)
        setVideoMedia(null)
    }

    const handlePostUpload = async (e) => {
        if(!readyToUpload){
            return;
        }
        else{
            setUploadBtnState("UPLOADING...")
            if(mediaType == 1){
                await uploadPost(
                    body,
                    location,
                    cropper.getCroppedCanvas().toDataURL(),
                    1,
                    monitization
                )
            }else{
                await uploadPost(
                    body,
                    location,
                    videoMedia,
                    2,
                    monitization
                )
            }
            setUploadBtnState("DONE!")
        }
    }

    useEffect(()=>{
        console.log(userData)

        if(userData.isCreator ){
            if((imageMedia || videoMedia)){
        console.log("Monetization: ", monitization)

               if(monitization == 0){
                    setReadyToUpload(true)
                }
                else if(monitization == 1 && price != 0)
                    setReadyToUpload(true)
                else
                    setReadyToUpload(false)
            }else{
                setReadyToUpload(false)
            }
        }else{
            if(imageMedia || videoMedia){
                setReadyToUpload(true)
            }else{
                setReadyToUpload(false)
            }
        }
    }, [location, body, isMediaSelected, monitization, price])


    return (
        <div className="upload-wrapper">
            <div className="upload-column-left" >
                <Header img={isMobile ? "backbutton.svg" : "plus.svg"} handleClick={isMobile ? goback : undefined} text="New Post" />
                {!isMediaSelected && <input
                    accept="image/*|video/*"
                    onChange={handleMediaChange}
                    type="file" style={{ display: 'none' }} id="lovrPhotoDrop" />}
                {!isMediaSelected && <label for="lovrPhotoDrop">
                    <div className={isDark ? "new-post-container dark-background" : "new-post-container light-background"} >
                        <div className="upload-options">
                            <img src={require("../../assets/icons/dragdrop.svg")} />
                            <h1>Drag & Drop</h1>
                        </div>

                        <div className="upload-options">
                            <p>OR</p>
                        </div>

                        <div className="upload-options">
                            <img src={require("../../assets/icons/upload_file.svg")} />
                            <h1>Upload media</h1>
                        </div>

                        <div className="upload-options-mobile">
                            <img src={require("../../assets/icons/upload_file.svg")} />
                            <h1>Select from storage</h1>
                        </div>
                        <div id="mediaDragArea" onDrop={handleOnDrop} onDragOver={handleOnDragOver}>

                        </div>
                    </div>
                </label>}

                {(isMediaSelected && mediaType == 1) && <div id="imageEditorWrapper">
            
                    <div id="cancel-button" onClick={handleRemoveMediaFile}>
                    <div>
                        <p>Change photo</p>
                    </div>
                    </div>
                    <Cropper
                        style={{ height:'100%', maxHeight: '520px', width: "100%", marginTop: '15px', borderRadius: '10px' }}
                        initialAspectRatio={1}
                        preview=".img-preview"
                        src={imageMedia}
                        viewMode={1}
                        aspectRatio={1 / 1}
                        guides={true}
                        minCropBoxHeight={10}
                        minCropBoxWidth={10}
                        background={false}
                        responsive={true}
                        autoCropArea={1}
                        checkOrientation={false}
                        onInitialized={(instance) => {
                            setCropper(instance);
                        }}
                    /> </div>}

                {(isMediaSelected && mediaType == 2) && <div id="videoWrappr">
                <div id="cancel-button" onClick={handleRemoveMediaFile}>
                    <div>
                        <p>Change video</p>
                    </div>
                    </div>

                    <video style={isDark ? { background: '#2d3134', borderRadius: '15px', marginTop: '25px' } : { background: '#ffffff', borderRadius: '15px', marginTop: '25px' }} autoPlay={true} controls={true} src={videoMedia} muted={true} loop={true}/>
                </div>}
            </div>
            <div className="upload-column-right" >
                <Header img='pencil.svg' text="Post Description" />
                <div className="right-column-mid">
                    <AuthInput handleInputChange={e => setBody(e.target.value)} icon="pencil.svg" type="text" placeholder="Description" />
                    <AuthInput handleInputChange={e => setLocation(e.target.value)} icon="location.svg" type="text" placeholder="Location" />
                    <div className="monitization-wrapper">
                        {userData.isCreator && <h2>Monetization</h2>}
                        {userData.isCreator  && <Monetization handleMonetization={(e) => setMonitization(e)} />}
                        {
                            monitization == 0 ?
                                userData.isCreator  && <p2>Free posts will be available to everyone.</p2> :
                                userData.isCreator  && <p2>Paid posts will be available for your subscribers and can be purchased individually by everyone.</p2>
                        }
                    </div>
                    {userData.isCreator == 1 && monitization == 1 && <div> <Input isError={priceError != null ? true : false} type='number' max={60} icon="tip.svg" value={price} placeholder="Enter Price" setValue={setPrice} handleInputChange={handlePrice} />
                        <div className='price-error-block'>
                            {
                                priceError != null && <ErrorValidator text={priceError} />
                            }
                        </div>
                    </div>
                    }
                </div>
                <button onClick={handlePostUpload} className={readyToUpload ? 'ready-upload' : 'not-ready-upload'}>
                  {readyToUpload ? <img src={require('../../assets/icons/upload_a.svg')}/> : <img src={require('../../assets/icons/upload.svg')}/>} <p>{uploadBtnState}</p> 
                </button>
                {/* <ButtonRed handleOnClick={(readyToUpload) ? handleUploadPost : () => { alert('tata, gya, khatam') }} icon="upload_a.svg" text={uploadBtnState} /> */}
            </div>
        </div>
    )
}
